export default __webpack_public_path__ + "c433110708a6e52a2990b74a1a29c21f.png";